module.exports = __webpack_public_path__ + "./kit/docs/img/icon-protocol.d87c3fd1648e10d56f19cb5d852e4d6e.svg";